import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import { GuidedHouseholdReviewDateTableSection } from 'Components/UI/guidedHouseholdReview/dateTableSection';
import { GuidedHouseholdReviewSection } from './section';

const metaOverrideSet = buildFacetDesignOverride();

export const GuidedHouseholdReviewSections = ({ collection, shownAsDateTable = false, outlined = true }) => {
  const sectionResources = collection.resources().list();

  const Layout = shownAsDateTable ? GuidedHouseholdReviewDateTableSection : GuidedHouseholdReviewSection;

  return (
    <>
      {sectionResources.map(resource => (
        <MetaResourceRenderer
          key={resource.id()}
          metaOverrideSet={metaOverrideSet}
          layout={Layout}
          LayoutProps={{ outlined }}
          resource={resource}
        />
      ))}
    </>
  );
};

GuidedHouseholdReviewSections.propTypes = {
  collection: PropTypes.instanceOf(fr.Collection).isRequired,
  metaOverrideSet: PropTypes.object.isRequired,
};
